const ags = [
    {
        name: 'Basketball',
        img: '/assets/icons/ogs/basketball.png',
        imgText: 'Basketball Icon',
        class: '1 - 3',
        text: 'Diese AG legt den Fokus auf die Grundtechniken des Basketballs.\n\nDabei lernen die Kinder das Passen, Fangen, Dribbeln und Werfen des Basketballs. Ebenfalls werden Wettbewerbe wie Wurfspiele, Staffelläufe, sowie spiele von 1-1 bis 4-4 gemacht.\n\nDarüber hinaus ist eine Teilnahme an der Grundschulliga, einer eigenen Liga des Vereins, in der alle Grundschulen aus Bad Honnef und Umgebung gegeneinander spielen, möglich.\n\nDie AG findet in Kooperation mit den Dragons Rhöndorf 1912 e.V. statt.'
    },
    {
        name: 'Basteln',
        img: '/assets/icons/ogs/basteln.png',
        imgText: 'Basteln Icon',
        class: '1 - 4',
        text: 'Bei dieser AG handelt es sich meist um einfache handwerkliche Tätigkeiten.\n\nAus einfachen Materialien wie Papier, Holz, Wolle oder Stoff werden schöne Dinge hergestellt.\n\nDie Kinder werden in der Feinmotorik, Kreativität und Geduld gefördert und haben einen Riesenspaß, wenn sie ihre fertigen Kunstwerke zu Hause präsentieren können.'
    },
    {
        name: 'Bücherwurm',
        img: '/assets/icons/ogs/buecherwurm.png',
        imgText: 'Bücherwurm Icon',
        class: '1 - 2',
        text: 'Diese AG weckt die gemeinsame Lust am Lesen.\n\nEs werden spannende Geschichten, alte Märchen, Abenteuer- und Rätselbücher sowie lustige Geschichten gelesen. Die Kinder lesen eigenständig/gemeinsam oder lauschen Geschichten und sprechen über Inhalte.'
    },
    {
        name: 'Flummis kommen zur Ruhe',
        img: '/assets/icons/ogs/flummis.png',
        imgText: 'Flummis kommen zur Ruhe Icon',
        class: '1 - 4',
        text: 'Diese AG weckt die Fantasie der Kinder mit Geschichten.\n\nFantasiereisen sollen Vorstellungen wecken, sowie Erlebnisse vermitteln. Dabei werden Spannungen bei Kindern abgebaut und die Kreativität gleichzeitig gefördert.\n\nSie lernen dabei das Empathievermögen und den Perspektivenwechsel weiterzuentwickeln. Das passiert, indem sie sich in unbekannte Rollen und Situationen hineinversetzten.\n\nDie Dinge, die sie in den Geschichten sehen und erleben, werden anschließend gemalt, gezeichnet oder aufgeschrieben.'
    },
    {
        name: 'Forscher - bleiben neugierig',
        img: '/assets/icons/ogs/forscher.png',
        imgText: 'Forscher - beleiben neugierig Icon',
        class: '1 - 2',
        text: 'Diese AG weckt die Freude am Entdecken von naturwissenschaftlichen Phänomenen.\n\nEs wird experimentiert, beobachtet und gemeinsam nach Erklärungen gesucht.\n\nMit alltäglichen, natürlichen Stoffen wird herausgefunden, wozu man sie anderweitig nutzen kann.\n\nExperimente fördern kreatives, erfinderisches und kritisches Denken.'
    },
    {
        name: 'Fußball',
        img: '/assets/icons/ogs/fussball.png',
        imgText: 'Fußball Icon',
        class: '1 - 2',
        text: 'Diese AG zeigt den Kindern den Spaß an Bewegung mit dem Ball.\n\nTechniken, Koordination und Handlungsschnelligkeit erleichtern den Umgang mit dem Ball im Spiel. Durch die klaren Regeln im Fußball wird der gegnerische Körperkontakt akzeptiert und die Persönlichkeit der Kinder ausgebildet. Fairness steht dabei immer im Vordergrund!'
    },
    {
        name: 'Handball',
        img: '/assets/icons/ogs/handball.png',
        imgText: 'Handball Icon',
        class: '3 - 4',
        text: 'In dieser AG lernt man die Grundzüge dieser schnellen Sportart kennen.\n\nPrellen, Passen, Fangen und Werfen lernen in der Handball-AG: Endlich mal etwas Neues probieren! Viel Bewegung, Einsatz und Teamplay sind hier gefragt. '
    },
    {
        name: 'Musik',
        img: '/assets/icons/ogs/musik.png',
        imgText: 'Musik Icon',
        class: '1 - 2',
        text: 'Diese AG bietet den Kindern die Möglichkeit, grundlegende musikalische Dinge wie Rhythmus, Taktgefühl und Melodik genauso zu lernen wie die Anfänge am Instrument.\n\nZiel ist es, Spaß und Freude bei den Kindern zu wecken sowie ihr Selbstbewusstsein zu stärken.'
    },
    {
        name: 'Spaß in Bewegung',
        img: '/assets/icons/ogs/spass.png',
        imgText: 'Spaß in Bewegung Icon',
        class: '1 - 2',
        text: 'Diese AG ist Alles, außer Sitzen!\n\nEs wird gelaufen, gehüpft, gesprungen, ausprobiert, Neues kennengelernt, Stress abgebaut und die Kinder bekommen den Kopf frei. Dies alles ohne Zwang und Leistungsdruck. Spielerisch die Bewegungskreativität fördern, dabei die Selbstwahrnehmung schulen, den Umgang mit Stärken und Schwächen kennenlernen und gleichzeitig auch noch Glückshormone freisetzen!\n\nBewegung aus Spaß an der Freude!'
    },
    {
        name: 'Tanz',
        img: '/assets/icons/ogs/tanz.png',
        imgText: 'Tanz Icon',
        class: '1 + 3',
        text: 'Diese AG fördert den Spaß am Tanzen.\n\nDabei wird sich im Rhythmus der Musik bewegt und Gruppentänze erlernt. Hier ist für jeden was dabei, Hip-Hop, Videoclipdancing, Stoptanz und Saisontänze werden ausprobiert.'
    },
    {
        name: 'Tischtennis',
        img: '/assets/icons/ogs/tischtennis.png',
        imgText: 'Tischtennis Icon',
        class: '3 - 4',
        text: 'Diese AG zeigt den Kindern den schnellen Spaß am kleinen Ball.\n\nDabei werden die Steigerung der koordinativen Körperbeherrschung und die sozialen Kompetenzen der Kinder gefördert. Dieses Spiel hat klare Regeln, denn Schummeln geht nicht. Er kann von 1-1 bis 2-2 Spiele geben. Dieser Sport wird den Kindern auf abwechslungsreiche und unterhaltsame Weise nähergebracht.\n\nTischtennis ist anspruchsvoll für Körper und Geist!'
    },
    {
        name: 'Upcycling',
        img: '/assets/icons/ogs/upcycling.png',
        imgText: 'Upcycling Icon',
        class: '2 - 4',
        text: 'Diese AG zeigt den Kindern, wie man aus alten Dingen coole, neue Dinge macht.\n\nIn dieser AG wird gebastelt, aber nur mit Gegenständen, die eigentlich nicht mehr genutzt werden, wie zum Beispiel Eierkartons, alte Gläser, Dosen etc.\n\nBei diesem Kurs lernen die Kinder, dass man nicht alles in den Müll schmeißen muss, sondern alte Dinge weiter nutzen kann.'
    }

]

export default ags;